import { render } from "./NavbarElementUpdated.vue?vue&type=template&id=e0965c44&scoped=true"
import script from "./NavbarElementUpdated.vue?vue&type=script&lang=js"
export * from "./NavbarElementUpdated.vue?vue&type=script&lang=js"

import "./NavbarElementUpdated.vue?vue&type=style&index=0&id=e0965c44&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0965c44"]])

export default __exports__